import type { JwtContent } from '@/types'

export const JwtParser = (token: string): JwtContent | null => {
  try {
    const base64Url = token.split('.')[1]!
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const payload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((char) => {
          return '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )

    return JSON.parse(payload)
  } catch {
    return null
  }
}
